<template>
    <div class="page-box main-container">
        <Tabs :value="activeTab" @on-click="change" :animated="false">
            <!-- <template #extra>
                <Button type="primary" @click="$refs.runModal.open({1})">
                    计算考核结果</Button>
            </template> -->
            <TabPane label="晋升考核" name="1">
                <rise-rank ref="riseRank" @open="(data,params) => $refs.runModal.open(data,params)"></rise-rank>
            </TabPane>
            <TabPane label="维持考核" name="2">
                <keep-rank ref="keepRank" @open="(data,params) => $refs.runModal.open(data,params)"></keep-rank>
            </TabPane>
        </Tabs>
        <runModal :organizationList="organizationList" :type="activeTab" ref="runModal" @success="getList"></runModal>
    </div>
</template>

<script>
import runModal from "./components/runModal";
import keepRank from './components/keepRank/index';
import riseRank from './components/riseRank/index';
export default {
    props: {},
    components: {
        keepRank,
        riseRank,
        runModal
    },
    data() {
        return {
            organizationList: [],
            loading: false,
            activeTab: '1'
        };
    },
    mounted() {
        this.queryOrganizationList();
        if (sessionStorage.promotionManage_tab) {
            this.change(sessionStorage.promotionManage_tab)
            sessionStorage.removeItem('promotionManage_tab')
        }
    },
    methods: {
        getList() {
            if (this.activeTab == 1) {
                this.$refs.riseRank.getList()
            } else {
                this.$refs.keepRank.getList()
            }
        },
        //查询所有机构
        queryOrganizationList() {
            this.$http({
                url: '/buz/organizationBase/queryDataOrganizations',
                type: "PUT",
                data: {}
            }).then(res => {
                this.organizationList = res.data;
            })
        },
        //获取机构晋升达标员工列表
        change(tab) {
            this.activeTab = tab;
            if (tab == '1') {
                this.$refs.riseRank && this.$refs.riseRank.getList();
            } else {
                this.$refs.keepRank && this.$refs.keepRank.getList();
            }
        }
    }
};
</script>

<style scoped lang="scss">
@import './index.scss';
</style>
